import { CardHeader } from "react-bootstrap";

const PanelCardHeader = ({children}) => {

    return (
        <CardHeader className="fs-4 fw-bold px-4 py-3 bg-darker d-flex justify-content-between align-items-center">
            {children}
        </CardHeader>
    );
}

export default PanelCardHeader;